module.exports = __webpack_public_path__ + "static/media/rustore_badge_en_color_40.4138c85a.svg";